import React from 'react'
import { StatTableHeader } from './StatTableHeader'
import { UserPositions } from './UserPositions'
import { format } from "date-fns"
export const UserDailyProgress = (
  {
    data,
    stagesRowsRender,
    user,
    payload
  }
) => {

  return (
    <div className={`flex flex-col my-[3.6rem]`}>
      {data.map(({date, readableDate, stages}) => {
        const dateFormated = format(new Date(date), 'dd.MM.yyyy')
        const modifiedPayload = {
          ...payload,
          dateFrom: dateFormated,
          dateTo: dateFormated,
        }
        return (
          <div key={date}>
            <div
              className={`text-Regular(24_30) sticky top-[0] z-10 pt-[2rem] font-bold pb-[1rem] bg-Dominant/Dop`}>
              {user.username}: {readableDate}
            </div>
            <StatTableHeader />
            {!!stages.length && stagesRowsRender(stages)}
            {!!stages.length &&
              <UserPositions stages={stages} user={user} payload={modifiedPayload} />}
          </div>
        )
      })}
    </div>
  )
}